import type { AssetsBatchEditConditionRatingProps } from "./assets-batch-edit-condition-rating.type";

import { useTranslation } from "react-i18next";

import { AssetConditionRatingField } from "@/modules/asset/asset-condition-rating-field";
import BatchEditForm from "@/modules/batch-edit-form";

import { useAssetsBatchEditConditionRating } from "./assets-batch-edit-condition-rating.hook";

export const AssetsBatchEditConditionRating = ({
  assets,
}: AssetsBatchEditConditionRatingProps) => {
  const { t } = useTranslation();
  const {
    form,
    fieldName,
    initialValue,
    onFormChange,
    onFormSubmit,
    isPending,
    hasChanges,
    hasError,
    fieldApiError,
  } = useAssetsBatchEditConditionRating(assets);

  return (
    <BatchEditForm
      modelKey="asset"
      form={form}
      fieldName={fieldName}
      initialValue={initialValue}
      onFormChange={onFormChange}
      onFormSubmit={onFormSubmit}
      isPending={isPending}
      hasChanges={hasChanges}
      hasError={hasError}
    >
      <AssetConditionRatingField
        name={fieldName}
        label={t("asset:batchEdit.conditionRating.label")}
        placeholder={t("asset:batchEdit.conditionRating.label")}
        validateStatus={fieldApiError ? "error" : "success"}
        help={fieldApiError}
      />
    </BatchEditForm>
  );
};
